import api from "../../../api/comptabilite/_comptes";

const state = () => ({
    compte_active_user: [],
    dernier_solde_cloture: 0,
    statut_ouverture_caisse: 0,
    date_ouverture_caisse_non_cloturee: '',
    liste_source_approvisionnement: [],

    etat_ouverture_caisse: {},
    is_closing_cash: false
});

// getters
const getters = {
    compteActiveUser: (state) => {
        return state.compte_active_user;
    },

    dernierSoldeCloture: (state) => {
        return state.dernier_solde_cloture;
    },

    statutOuvertureCaisse: (state) => {
        return state.statut_ouverture_caisse;
    },

    dateOuvertureCaisseNonCloturee: (state) => {
        return state.date_ouverture_caisse_non_cloturee;
    },

    liste_source_approvisionnement: (state) => {
        return state.liste_source_approvisionnement;
    },

    etat_ouverture_caisse: (state) => {
        return state.etat_ouverture_caisse;
    },

    is_closing_cash: (state) => {
        return state.is_closing_cash;
    },

};
// mutations
const mutations = {
    SET_COMPTE_ACTIVE_USER(state, compte) {
        state.compte_active_user = compte;
    },

    SET_DERNIER_SOLDE_CLOTURE(state, solde) {
        state.dernier_solde_cloture = solde;
    },

    SET_STATUT_OUVERTURE_CAISSE(state, etat) {
        state.statut_ouverture_caisse = etat;
    },

    SET_DATE_OUVERTURE_CAISSE_NON_CLOTUREE(state, date) {
        state.date_ouverture_caisse_non_cloturee = date;
    },

    SET_LISTE_SOURCE_APPROVISIONNEMENT(state, solde) {
        state.liste_source_approvisionnement = solde;
    },

    SET_ETAT_OUVERTURE_CAISSE(state, solde) {
        state.etat_ouverture_caisse = solde;
    },

    SET_IS_CLOSING_CASH(state, solde) {
        state.is_closing_cash = solde;
    },
};

// actions
const actions = {

    getActiveCompteForUser({ commit }, idUser) {
        return new Promise((resolve, reject) => {
            api.getActiveCompteForUser(idUser).then(
                (response) => {
                    commit("SET_COMPTE_ACTIVE_USER", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Recupère le dernier solde de cloture d'une caisse donnée
     * @param {*} param0 
     * @param {*} compte_id 
     * @returns 
     */
    getDernierSoldeCloture({ commit }, compte_id) {
        return new Promise((resolve, reject) => {
            api.getDernierSoldeCloture(compte_id).then(
                (response) => {
                    commit("SET_DERNIER_SOLDE_CLOTURE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getStatutOuvertureCaisse({ commit }, compte_id) {
        return new Promise((resolve, reject) => {
            api.getStatutOuvertureCaisse(compte_id).then(
                (response) => {
                    commit("SET_STATUT_OUVERTURE_CAISSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    /**
     * Ouverture d'une caisse
     * @param {*} data 
     * @returns 
     */
    openCaisse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.openCaisse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Cloture d'une caisse
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    closeCaisse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.closeCaisse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Cloture d'une caisse avec versement
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    closeCaisseVersement({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.closeCaisseVersement(data[0]).then(
                response => {
                    dispatch('getStatutOuvertureCaisse', data[0].compte_id)
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },
    /**
     * Cloture d'une caisse avec versement
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    doCaisseVersement({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.doCaisseVersement(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    /**
     * Recupère les types de dépenses correspondant à un rôle donné
     * @param {*} 
     * @param {*} role_id 
     * @returns 
     */
    getTypeDepenses({ commit }, idRole) {
        return new Promise((resolve, reject) => {
            api.getTypeDepenses(idRole).then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getDateOuvertureCaisseNonCloturee({ commit }, compte_id) {
        return new Promise((resolve, reject) => {
            api.getDateOuvertureCaisseNonCloturee(compte_id).then(
                (response) => {
                    commit("SET_DATE_OUVERTURE_CAISSE_NON_CLOTUREE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeSourceApprovisionnement({ commit }) {
        return new Promise((resolve, reject) => {
            api.getListeSourceApprovisionnement().then(
                (response) => {
                    commit("SET_LISTE_SOURCE_APPROVISIONNEMENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getEtatOuvertureCaisse({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getEtatOuvertureCaisse(data).then(
                (response) => {
                    commit("SET_ETAT_OUVERTURE_CAISSE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
};